import { ReactComponent as logo } from "../../../assets/images/logo.svg";

export default logo;
